(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let container = document.querySelector('.blog-article-sort');
    let elements = Array.from(container.children);
    let sorted = elements.sort(function (a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    });
    container.innerHTML = '';
    sorted.forEach((elm) => container.append(elm));

    if (window.matchMedia('(max-width: 767px)').matches) {
    } else {
      let articleGridMasonry = new MiniMasonry({
        container: '.blog-article-masonry',
        minify: false,
        baseWidth: 450,
        gutter: 20,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let container = document.querySelector('.blog-article-sort');
    let elements = Array.from(container.children);
    let sorted = elements.sort(function (a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    });
    container.innerHTML = '';
    sorted.forEach((elm) => container.append(elm));

    if (window.matchMedia('(max-width: 767px)').matches) {
    } else {
      let articleGridMasonry = new MiniMasonry({
        container: '.blog-article-masonry',
        minify: false,
        baseWidth: 450,
        gutter: 20,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-tag-tabs"]) return;
  try {
    
  const container = document.querySelector('.clp-tag-card-list');
  const targetItem = document.querySelector('.clp-tag-card.active');
  const itemRect = targetItem.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const targetX = itemRect.left - containerRect.left + container.scrollLeft;
  container.scrollTo({
    left: targetX,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-blog-all-article-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let container = document.querySelector('.blog-article-sort');
    let elements = Array.from(container.children);
    let sorted = elements.sort(function (a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    });
    container.innerHTML = '';
    sorted.forEach((elm) => container.append(elm));

    if (window.matchMedia('(max-width: 767px)').matches) {
    } else {
      let articleGridMasonry = new MiniMasonry({
        container: '.blog-article-masonry',
        minify: false,
        baseWidth: 450,
        gutter: 20,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-landing-content-anchoring-grid"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      function gridMasanory() {
        let container = document.querySelector('.blog-article-sort');
        let elements = Array.from(container.children);
        let sorted = elements.sort(function (a, b) {
          return +a.dataset.sort - +b.dataset.sort;
        });
        const grid_columns = container.dataset.columns;
        let baseWidthValue;
        console.log("grid_columns: ", grid_columns);
        if (grid_columns == 5) {
          console.log("columns 5")
          if (window.matchMedia('(min-width: 1200px) and (max-width: 2400px)').matches) {
            baseWidthValue = (window.innerWidth / 5) - 20;
          } else {
            baseWidthValue = window.matchMedia('(max-width: 550px)').matches ? 150 :
                            window.matchMedia('(max-width: 767px)').matches ? 250 :
                            window.matchMedia('(max-width: 1240px)').matches ? 200 :
                            window.matchMedia('(max-width: 1390px)').matches ? 240 :
                            window.matchMedia('(max-width: 1700px)').matches ? 275 :
                            window.matchMedia('(max-width: 1804px)').matches ? 290 :
                            window.matchMedia('(max-width: 2250px)').matches ? 320 : 280;
          }
        } else {
          console.log("columns 3")
          baseWidthValue = window.matchMedia('(max-width: 550px)').matches ? 150 : window.matchMedia('(max-width: 767px)').matches ? 250 : window.matchMedia('(max-width: 1240px)').matches ? 350 : window.matchMedia('(max-width: 1390px)').matches ? 400 : window.matchMedia('(max-width: 1850px)').matches ? 450 : window.matchMedia('(max-width: 2250px)').matches ? 550 : 650;
        }

        container.innerHTML = '';
        sorted.forEach((elm) => container.append(elm));

        let articleGridMasonryMobile = new MiniMasonry({
            container: '.blog-article-masonry',
            minify: false,
            baseWidth: baseWidthValue,
            gutter: 10,
        });
      }

      gridMasanory();
      window.addEventListener('resize', gridMasanory);

      document.addEventListener('click', function (event) {
        // if (event.target.matches('[data-anchor-from]')) {
        //   // event.preventDefault();

        //   // const anchorFrom = event.target.getAttribute('data-anchor-from');
        //   // const targetSection = document.querySelector(`[data-anchor-to="${anchorFrom}"]`);
        //   // if (targetSection) {
        //   //   const headerHeight = document.querySelector('#header').offsetHeight || 0;
        //   //   const promoHeight = document.querySelector('#promobar').offsetHeight || 0;
        //   //   const sectionPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight - headerHeight - promoHeight;
        //   //   console.log()
        //   //   console.log(targetSection.getBoundingClientRect().top, targetSection.getBoundingClientRect().top + window.scrollY)
        //   //   window.scrollTo({
        //   //     top: sectionPosition,
        //   //     behavior: 'smooth',
        //   //   });

        //     // targetSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
        //   // }
        // }
      });



      
    });
  
  } catch(e) { console.error(e); }
})();
})();
